<script>
    export let data, change;
</script>
{#each data as row}
    <div class="col20 f-left func-option">
        <label>
            <input type="checkbox" disabled={row.disabled} bind:checked={row.checked} on:change={change}/>
            <span>{row.label}</span>
        </label>
    </div>
{/each}